export default {
  title: 'ExpertOrder',
  form: {
    api_key: {
      label: 'Chiave API',
    },
  },
  buttons: {
    save: 'Salva',
  },
  toasts: {
    error: 'Salvataggio delle modifiche non riuscito',
    success: 'Modifiche salvate',
  },
  connected: {
    title: 'ExpertOrder è connesso',
    description: 'Questa integrazione è configurata.',
  },
};
